// extracted by mini-css-extract-plugin
export default {"upload-slider":"upload-slider"};